import { ArrowUp, ChevronDown } from "lucide-react";
import { useEffect, useRef } from "react";

function MessageInput({ input, setInput, isLoading, onSubmit, backendContext }) {
  const textareaRef = useRef(null);

  // Auto-resize textarea
  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      const newHeight = Math.min(textarea.scrollHeight, 128);
      textarea.style.height = newHeight + "px";
    }
  }, [input]);

  const handleKeyDown = e => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (!isLoading && input.trim()) {
        onSubmit(e);
      }
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (!isLoading && input.trim()) {
      onSubmit(e);
    }
  };

  return (
    <div className="chat-input-area">
      <div className="chat-input-container">
        <form onSubmit={handleSubmit} className="chat-input-form">
          <div className="chat-input-main">
            <textarea
              ref={textareaRef}
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Ask about specific files, functions, or architecture..."
              className="chat-input-textarea"
              disabled={isLoading}
              rows={1}
            />
          </div>

          {/* Bottom toolbar with model selector and send button */}
          <div className="chat-input-toolbar">
            <div className="chat-input-tools">{/* Empty left side for future tools */}</div>

            <div className="chat-input-controls">
              {/* Model selector */}
              <button className="chat-model-selector" type="button">
                <span>GPT-4o</span>
                <ChevronDown size={14} />
              </button>

              {/* Send button */}
              <button
                type="submit"
                disabled={isLoading || !input.trim()}
                className="chat-send-button"
                title={isLoading ? "Generating response..." : "Send message"}
              >
                {isLoading ? <div className="chat-spinner"></div> : <ArrowUp size={16} />}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default MessageInput;
